import { setupIonicReact } from "@ionic/react";

/*
 * CSS Import Order:
 * 1. Core Ionic CSS (required for Ionic components)
 * 2. CSS Reset/Normalize
 * 3. Optional Ionic Utilities
 * 4. Swing Global Styles
 */

/* 1. Core Ionic CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";

/* 2. CSS reset for apps built with Ionic */
import "@ionic/react/css/normalize.css";

/* 3. Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";

/* 4. Theme Styles - ionic overrides, globals, fonts and colors */
import "swing-styles";

/* Required for React Ionic */
setupIonicReact({ mode: "md" });
